<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<p style="text-align: center;margin-top:110px;margin-bottom:25px;"><img alt="" src="media/file1.jpg" style="width:4.40645in;height:4.16079in"/></p>
<h1>Introduction</h1>
<p style="text-align: center;">Calm Pond is in Blackstone Edge. It is a wonderful place, a special place. It is quiet and beautiful. You could say it is my heaven on earth.</p><br/>
<p style="text-align: center;">It is not just my special place, though. It is also the home of some amazing creatures. The creatures of Calm Pond live together, work together and help each other to form a strong community.</p><br/>
<p style="text-align: center;">The following stories are about these creatures, my friends.</p><br/>
<p style="text-align: center;">Richard Clarke</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?6ae0a828